import { bindable } from "aurelia-templating";

export class TagsInputFilter {

    public input: HTMLInputElement;
    public focused: boolean = false;

    @bindable
    public tags: string[] = [];

    @bindable
    public maxNumberOfTags: number = 10;

    @bindable
    public tagMaxLength: number = 30;

    @bindable
    public label: string;

    @bindable
    disabled: boolean = false;

    @bindable
    readonly: boolean = false;

    @bindable
    allowAdd: boolean = true;

    onKeyDownForTag($event: KeyboardEvent): boolean {
        if (this.disabled) {
            return false;
        }
        const element: any = this.input;
        if (element.value && element.value.length > 0) {
            if ($event.code === "Enter") {
                this.pushNewTag(element.value);
                element.value = null;
            }
            element.size = element.value.length + 1;
        }
        return true;
    }

    focus() {
        if(this.input) {
            this.focused = true;
            this.input.focus();
        }
    }

    stopPropagation($event) {
        $event.stopPropagation();
    }

    private pushNewTag(tag) {
        if(!this.allowAdd)
            return;
        if (!this.tags.some(x => x === tag) && tag && tag.length > 0) {
            this.tags.push(tag);
        }
    }

    remove($event, $index: number): void {
        $event.stopPropagation();
        this.tags.splice($index, 1);
    }

    onFocus(): boolean {
        if (this.disabled) {
            return false;
        }
        this.input.size = 1;
        return true;
    }

    onBlur(): void {
        const element: any = this.input;
        this.input.size = 1;
        this.pushNewTag(element.value);
        element.value = null;
        this.focused = false;
    }
}
